import { Link } from 'react-router-dom';
import { Empty, ErrorState, Loading } from '@/components/common/State';
import CartLineItem from '@/components/cart/CartLineItem';
import CartSummary from '@/components/cart/CartSummary';
import { useCart } from '@/components/cart/useCart';

export default function CartPage() {
  const cart = useCart();
  const { user, data, isLoading, isError, error, refetch } = cart;

  if (!user) {
    return (
      <Empty title="로그인이 필요합니다.">
        <Link to="/login?redirect=/cart" className="btn btn--primary btn--sm">
          로그인하기
        </Link>
      </Empty>
    );
  }

  if (isLoading) return <Loading />;
  if (isError) return <ErrorState error={error} onRetry={refetch} />;
  if (!data || data.items.length === 0) {
    return (
      <Empty title="장바구니가 비어 있습니다.">
        <Link to="/products" className="btn btn--primary btn--sm">
          상품 둘러보기
        </Link>
      </Empty>
    );
  }

  return (
    <>
      <h1 className="panel-title">장바구니</h1>

      <div className="cart-layout">
        <div>
          {data.items.map((item) => (
            <CartLineItem key={item.cartItemId} item={item} cart={cart} />
          ))}
        </div>

        <div className="card summary-box">
          <div className="card__body">
            <CartSummary cart={cart} />
          </div>
        </div>
      </div>
    </>
  );
}
